export function getPremiumContentFor(archetype: string) {
  const data: Record<string, any> = {
    jaguar: {
      fullTitle: "Jaguar",
      description:
        "El Jaguar es un líder estratégico y decisivo que impone respeto mediante acciones calculadas y autoridad natural.",
      intro:
        "El Jaguar es un profesional poderoso, estratégico y con una intensa determinación. Lideras con enfoque, ambición y un claro sentido de propósito. Como el jaguar en la naturaleza, te mueves con confianza e intención. Otros suelen buscarte para obtener guía, claridad y decisiones audaces.<br/><br/>Prosperas en situaciones que exigen fortaleza, liderazgo y la habilidad de minimizar el ruido para enfocarte en lo esencial. Tu presencia impone respeto, no por volumen, sino por certeza. Cuando estás alineado con una misión, te conviertes en una fuerza imparable para el progreso.<br/><br/><i><b>Perspectiva del Coach José Piñero:</b> Los Jaguares no esperan a que las puertas se abran: construyen la puerta, la derriban y luego invitan a otros a pasar. Lidera con estrategia y humanidad en igual medida.</i>",
      shortintro:
        "El Jaguar es un líder audaz y enfocado que prospera ante los desafíos, toma decisiones estratégicas y se mueve con autoridad tranquila.",
      archnarrative:
        "En muchas tradiciones indígenas y latinas, el jaguar representa poder, misticismo y el papel sagrado del protector. Como Jaguar moderno, eres el guardián del propósito. Ves la visión a largo plazo, entiendes los sistemas y, con frecuencia, asciendes de manera natural a posiciones de liderazgo, ya sean formales o informales.<br/><br/>No rehúyes el conflicto si está en juego la integridad del trabajo. Eres un impulsor, un constructor y, a menudo, un solucionador. Pero tu mayor fortaleza radica en saber cuándo liderar desde el frente y cuándo empoderar a otros para que brillen.<br/><br/><b>Si te sientes estancado:</b> Puede que estés asumiendo demasiado, intentando hacerlo todo solo. Haz una pausa. Delegar también es liderazgo. Liderar no significa hacerlo todo, sino crear las condiciones para la excelencia.",
      strengths: [
        "Pensador estratégico a largo plazo",
        "Serenidad bajo presión",
        "Orientado a metas y misión",
        "Presencia de liderazgo fuerte",
        "Autodisciplina y determinación",
        "Toma-decisiones seguro de sí mismo",
        "Resuelve-problemas con altos estándares",
      ],
      quicktips:
        "Al tomar decisiones difíciles, pregúntate: “¿Cuál es la acción de mayor impacto que puedo hacer alineada con mi visión?”",
      growthAreasIntro:
        "Incluso los líderes más fuertes necesitan crecer. Los Jaguares pueden trabajar en:",
      growthAreas: [
        "<strong>Paciencia con colegas menos motivados o capaces:</strong> No todos se mueven con tu misma velocidad o urgencia. Construye puentes, no presión.",
        "<strong>Humildad colaborativa:</strong> Invita opiniones diversas desde el inicio, no solo después de decidir.",
        "<strong>Soltar el control:</strong> Delega no solo tareas, sino confianza.",
        "<strong>Comunicación más cálida:</strong> Tu fuerza puede intimidar. Practica cercanía y empatía.",
      ],
      microCoachingTips:
        "En reuniones, haz una pregunta poderosa en lugar de una afirmación. Lidera con curiosidad, no solo con claridad.",
      careerAdvice:
        '<p class="text-gray-700 mb-4">Prosperas donde se cruzan estrategia, liderazgo y ejecución. Busca roles que te pongan al mando, pero no en aislamiento. Das lo mejor rodeado de equipos capaces y misiones claras.</p><p class="text-gray-700 mb-4">Busca:</p><ul><li>● Organizaciones con propósito</li><li>● Roles estratégicos con potencial de crecimiento</li><li>● Rutas hacia puestos ejecutivos o equipos intraemprendedores</li><li>● Proyectos con autonomía y resultados medibles</li></ul><p class="text-gray-700 mb-4">Evita entornos con microgestión, burocracias lentas y lugares donde tu ambición se perciba como “demasiado”.</p><p class="text-gray-700 mb-4"><i><b>Microconsejo:</b> Pregúntate cada trimestre: “¿Estoy creciendo o solo esforzándome sin avanzar?”</i></p>',
      personalizeRoadMap: {
        initial: [
          "Identifica un proyecto estratégico para liderar o co-liderar",
          "Agenda 1:1 con 2–3 mentores clave",
          "Define tus valores personales de liderazgo",
        ],
        midterm: [
          "Participa como voluntario en una iniciativa de liderazgo interfuncional",
          "Presenta una solución a un problema recurrente del equipo",
          "Delega al menos una responsabilidad importante",
        ],
        longterm: [
          "Desarrolla tu voz de liderazgo: comienza a escribir o dar charlas",
          "Mentorea a un miembro en crecimiento",
          "Evalúa tu energía: ¿qué roles te impulsan y cuáles te desgastan?",
        ],
        tips: "El liderazgo no es lo que haces, es cómo se sienten las personas a tu alrededor. Evalúa tu impacto.",
      },
      careerRoles: [
        "Líder de equipo o departamento",
        "Estratega de negocios",
        "Gerente de operaciones",
        "Director de producto",
        "Gerente de programas",
        "Consultor o asesor de políticas",
        "Emprendedor o intraemprendedor",
        "Ejecutivo en formación",
      ],
      rolesAvoidIntro:
        "Estos pueden subutilizar tus fortalezas o hacerte sentir limitado:",
      rolesAvoid: [
        "Roles de ejecución sin toma de decisiones",
        "Puestos administrativos repetitivos",
        "Organizaciones estáticas y resistentes al cambio",
        "Ambientes que desincentivan la ambición",
      ],
      prefferedWork: {
        intro:
          "Trabajas mejor en entornos que valoran la autonomía, el impacto y la dirección. Eres planificador, ejecutor y pensador. Te gustan la claridad, el progreso y el movimiento, y tienes estándares altos.",
        need: [
          "Claridad en la misión",
          "Ambientes de alta confianza",
          "Oportunidades para liderar",
          "Responsabilidad sin microgestión",
        ],
        tip: "Comparte tu visión con frecuencia. Inspira y alinea a otros para actuar.",
      },
      idealEnvironment: {
        need: [
          "Empresas o iniciativas con propósito",
          "Espacios que premian resultados, no solo esfuerzo",
          "Equipos con metas claras y liderazgo sólido",
          "Lugares que confían en los profesionales para lograr resultados",
        ],
        story:
          "Rafael, un Jaguar, ascendió de analista senior a VP de estrategia en 3 años al proponer un nuevo sistema de métricas para la empresa. Su reputación como estratega confiable y sereno lo hizo indispensable.",
      },
      aiPrompts: {
        title: "Prompts de IA para el Crecimiento del Jaguar",
        intro: "Úsalos con herramientas de Inteligencia Articifial para enfocar tu desarrollo:",
        need: [
          "“¿Cuáles son los mejores libros de liderazgo para alguien orientado a la acción y la estrategia?”",
          "“Ayúdame a diseñar un plan de acción de 90 días para liderar un nuevo equipo como Jaguar.”",
          "“¿Cómo dar retroalimentación constructiva con empatía?”",
          "“Crea una plantilla semanal para líderes de equipos de alto desempeño.”",
        ],
        tip: "Añade “como Jaguar” al prompt para que la IA entienda tu estilo de liderazgo.",
      },
      affirmation:
        "Lidero con valentía, claridad y convicción. Convierto la visión en estrategia y la estrategia en acción.",
      latinovalues: {
        intro:
          "Esto significa que te atraen el propósito, el rendimiento y el honor. A menudo eres el ancla de integridad y avance dentro de equipos, familias y comunidades.",
        values: ["Autoridad", "Tenacidad y Empuje", "Crecimiento", "Orgullo Cultural"],
      },
      powerQuote:
        "Estás aquí para construir. Para guiar. Para crecer. Lidera con claridad, actúa con corazón y recuerda: tu poder no está solo en lo que logras, sino en cómo elevas a los que te rodean.<br/><br/><b>Haz tuyo el camino. Diseña tu futuro. Sé el Jaguar.</b>",
    },
    llama: {
      fullTitle: "Llama",
      intro:
        "La Llama es el profesional confiable, estable y orientado al servicio. Eres la presencia constante en la que otros confían. Como la llama que carga peso a través de las montañas con paciencia y fuerza silenciosa, aportas consistencia, calma y cuidado a tu trabajo.<br/><br/>Tu presencia suele ser el ingrediente clave que mantiene unidos a los equipos. No eres la voz más fuerte, pero tu fiabilidad, lealtad y enfoque basado en valores construyen confianza y armonía con el tiempo. En un mundo lleno de ruido, tu ritmo constante es un regalo raro y valioso.<br/><br/><i><b>Perspectiva del Coach José Piñero:</b> Las llamas lideran sirviendo—no desde el centro de atención, sino desde su integridad. Pero no lo olvides: tu voz importa. Da un paso al frente con más frecuencia.</i>",
      description:
        "Leal. Con los pies en la tierra. Confiable. Como llama, eres la calma en la tormenta: la persona en la que los demás confían cuando las cosas se ponen difíciles. Lideras estando presente, perseverando y manteniendo las cosas en marcha cuando otros flaquean. No necesitas atención. Te ganas la confianza.",
      shortintro:
        "La Llama es un profesional confiable, leal y orientado a la armonía, que prospera en roles que requieren consistencia, confianza y empatía.",
      archnarrative:
        "La Llama ha sido durante mucho tiempo símbolo de resistencia y responsabilidad en la cultura latinoamericana. En las tierras altas, se confía en las llamas para llevar cargas a largas distancias. De forma similar, como profesional, llevas proyectos, personas y responsabilidades con cuidado y compromiso.<br/><br/>Probablemente eres la persona en quien tus compañeros confían para dar seguimiento. Notas las necesidades no expresadas. Te aseguras de que nada ni nadie se quede atrás. Lideras con fuerza tranquila, pero cuando te ignoran o no valoran, puedes retraerte en lugar de hablar.<br/><br/><b>Si te sientes estancado:</b> Puede que estés cargando más de lo que te corresponde o que no estés defendiendo tus necesidades. Practica pedir apoyo. No tienes que hacerlo todo solo.",
      strengths: [
        "Estabilidad y fiabilidad bajo presión",
        "Lealtad y compromiso con el equipo",
        "Consistencia emocional",
        "Atención al detalle y minuciosidad",
        "Mediadora natural",
        "Altamente confiable y responsable",
      ],
      quicktips:
        "Haz una lista de tres cosas que solo tú puedas hacer excepcionalmente bien. Deja que otros te apoyen en el resto.",
      growthAreasIntro:
        "Incluso los arquetipos más sólidos pueden crecer. Como Llama, considera:",
      growthAreas: [
        "<strong>Defender tus necesidades:</strong> Tu fuerza silenciosa importa—pero tu voz también debe escucharse.",
        "<strong>Establecer límites:</strong> Tu naturaleza servicial puede llevarte al agotamiento. Aprende a decir no con amabilidad.",
        "<strong>Aceptar visibilidad:</strong> Puedes evitar el reconocimiento. Acéptalo—te lo has ganado.",
        "<strong>Pedir retroalimentación:</strong> Te ayuda a crecer e invita a otros a apreciar tu trabajo más abiertamente.",
      ],
      microCoachingTips:
        "Cada semana, comparte una idea en una reunión o envía un correo destacando tu trabajo. La visibilidad genera oportunidades.",
      careerAdvice:
        '<p class="text-gray-700 mb-4">Busca entornos que valoren la consistencia, las habilidades interpersonales y la estructura. Brillas cuando la misión está clara y tu fiabilidad contribuye al éxito colectivo.</p><p class="text-gray-700 mb-4">Busca roles donde la inteligencia emocional, la confianza y los sistemas sean clave. Tu poder no está en la velocidad—está en la sostenibilidad.</p><p class="text-gray-700 mb-4">Busca:</p><ul><li>● Roles de apoyo operativo</li><li>● Puntos de anclaje en equipos o departamentos</li><li>● Liderazgo interno (RR. HH., People Ops, Administración)</li><li>● Organizaciones con cultura sólida y valores centrados en las personas</li></ul><p class="text-gray-700 mb-4 mt-4"><b>Evita:</b> Entornos caóticos, roles hipercompetitivos o lugares sin expectativas claras.</p><p class="text-gray-700 mb-4"><i><b>Microconsejo:</b> Pregunta en entrevistas: “¿Cómo maneja este equipo la presión y los plazos?” Busca alineación con tu ritmo estable.</i></p>',
      personalizeRoadMap: {
        initial: [
          "Aclara tus responsabilidades principales y cómo se mide el éxito",
          "Pide retroalimentación a un compañero de confianza sobre tus fortalezas",
          "Inicia un diario de “Logros bien hechos” para registrar tus victorias silenciosas",
        ],
        midterm: [
          "Propón una mejora de sistema o un ajuste de proceso",
          "Solicita apoyo en una tarea que te resulte agotadora",
          "Explora mentoría para otros que necesiten estructura o guía",
        ],
        longterm: [
          "Ofrécete para un rol que aumente tu visibilidad",
          "Pregunta a tu gerente por una promoción o un proyecto de liderazgo",
          "Crea un plan de sostenibilidad para cuidar tu bienestar",
        ],
        tips: "La sostenibilidad es tu superpoder. Construye un ritmo de cuidado—para ti y para los demás.",
      },
      careerRoles: [
        "Coordinador de RR. HH. o People Ops",
        "Gerente Administrativo",
        "Líder de Soporte al Cliente",
        "Asistente de Programas o Especialista en Operaciones",
        "Gerente de Experiencia del Equipo",
        "Gerente de Beneficios o Nómina",
        "Soporte Administrativo Escolar",
        "Coordinador de Bienestar Laboral",
      ],
      rolesAvoidIntro:
        "Estos roles pueden causarte estrés innecesario o desaprovechar tus fortalezas:",
      rolesAvoid: [
        "Ventas con alto nivel de drama o llamadas en frío",
        "Entornos caóticos con cambios constantes",
        "Roles que exijan autopromoción constante o marca personal",
        "Puestos con expectativas poco claras o liderazgo deficiente",
      ],
      prefferedWork: {
        intro:
          "Prosperas en entornos donde importan la consistencia, la confianza y la colaboración. Te gusta tener un rol claro, compañeros confiables y tiempo para hacer las cosas bien. Piensas primero en el equipo, pero te beneficias de independencia estructurada.",
        need: [
          "Estructura predecible",
          "Aprecio por el seguimiento",
          "PeEspacios centrados en las personas",
          "Seguridad emocional y claridad",
        ],
        tip: "Usa el “mapeo de lunes” para planificar tu semana y evitar sobrecargarte. La energía importa.",
      },
      idealEnvironment: {
        need: [
          "Equipos estables con mentalidad centrada en las personas",
          "Organizaciones que prioricen la cultura, el bienestar y el apoyo",
          "Gerentes que den objetivos claros y confíen en tu entrega",
          "Lugares de trabajo que valoren la lealtad y la entrega constante",
        ],
        story:
          "Ana, una Llama, trabajaba tras bambalinas como coordinadora de operaciones. Tras sugerir una mejora en el flujo de trabajo, fue ascendida y se le pidió capacitar a nuevos empleados—convirtiéndose en el ancla cultural confiable de su equipo.",
      },
      aiPrompts: {
        title: "AI Prompts for Llama Growth",
        intro: "Usa estos prompts para guiar tu desarrollo:",
        need: [
          "“Ayúdame a establecer límites en el trabajo sin sentir culpa.”",
          "“¿Cuál es la mejor manera de abogar por mí como miembro de equipo solidario?”",
          "“Diseña una rutina que equilibre consistencia laboral con descanso.”",
          "“¿Cómo puedo destacar mi confiabilidad e impacto en una entrevista?”",
          "“Dame ideas para decir ‘no’ sin sonar negativo.”",
        ],
        tip: "Añade “como Llama” para personalizar las respuestas a tu estilo laboral.",
      },
      affirmation:
        "“Soy estable, fuerte y confiable. Construyo confianza a través de la acción y lidero con poder silencioso.”",
      latinovalues: {
        intro:
          "Honras la comunidad, la tradición y la consistencia. Llevas más peso que la mayoría—y lo haces con orgullo. Pero recuerda: tu valor no está solo en lo que haces—está en quién eres.",
        values: ["Lealtad al Grupo", "Respeto", "Sacrificio", "Familia"],
      },
      powerQuote:
        "Eres el ritmo del equipo, la calma en la tormenta y el corazón detrás del esfuerzo. Hazte escuchar, da un paso al frente y deja que tu sabiduría enraizada moldee el futuro. <br/><br/><b>Haz tuyo tu camino. Mantente firme. Sé la Llama.</b>",
    },
    condor: {
      fullTitle: "Cóndor",
      intro:
        "El cóndor es el profesional sabio, reflexivo y visionario. Ves el mundo desde una perspectiva más elevada, escaneando el terreno mientras otros aún se enfocan en lo inmediato. Como el majestuoso cóndor que sobrevuela los Andes, eres reflexivo, estratégico y estás profundamente conectado al significado y al legado.<br/><br/>Aportas profundidad, paciencia y visión a tu trabajo. Mientras otros persiguen la urgencia, tú buscas comprensión. A menudo mantienes la visión a largo plazo—ayudando a los equipos a navegar la incertidumbre con calma, sabiduría y propósito.<br/><br/><i><b>Perspectiva del Coach José Piñero:</b> No solo trabajas—interpretas. No permitas que se subestime tu valor por hablar con suavidad. Tu perspectiva puede moldear el futuro.</i>",
      description:
        "Sabio. Estratégico. Centrado. Como Cóndor, ves lo que otros pasan por alto. No te apresuras, te elevas. Lideras con reflexión, actúas con intención y aportas calma y claridad incluso a los momentos más caóticos.",
      shortintro:
        "El Cóndor es un profesional reflexivo y con visión, que aporta sabiduría, calma y claridad a entornos complejos.",
      archnarrative:
        "En las tradiciones andinas y latinoamericanas, el cóndor es un ave sagrada—símbolo de la conexión entre el cielo y la tierra, entre el espíritu y la estrategia. Como Cóndor, tú eres ese puente.<br/><br/>Sueles ser la voz de la razón, quien espera, observa y habla solo cuando es necesario. Eres un estratega. Prefieres la profundidad al ruido, el legado a las modas. Tu poder silencioso da espacio para que otros crezcan.<br/><br/><b>Si te sientes estancado:</b> Tal vez estás esperando demasiado o te estás aislando en exceso. Tus ideas importan más de lo que crees—compártelas antes, no solo cuando te las pidan.",
      strengths: [
        "Visión estratégica profunda y a largo plazo ",
        "Alta madurez emocional y sabiduría ",
        "Perspicacia observacional y reconocimiento de patrones ",
        "Capacidad de mantener la calma bajo presión ",
        "Enraizamiento en valores y propósito ",
        "Paciencia ante la complejidad ",
      ],
      quicktips:
        "Escribe tus principales ideas cada semana, aunque no las expreses. Practica compartir una idea por reunión.",
      growthAreasIntro:
        "Incluso los arquetipos más sabios pueden crecer. Como Cóndor, presta atención a:",
      growthAreas: [
        "<strong>Sobre-aislamiento:</strong> Puedes retirarte demasiado en tus pensamientos. Crea espacio intencional para la colaboración. ",
        "<strong>Toma de decisiones lenta:</strong> Tu necesidad de minuciosidad puede frenar el progreso. Comienza con acción imperfecta.",
        "<strong>Subestimar la urgencia:</strong>A veces, ahora es mejor que después. Acepta la velocidad cuando genere impacto.",
        "<strong>Ser ignorado:</strong> Exprésate antes. Tu voz tranquila también tiene poder.",
      ],
      microCoachingTips:
        "Cada semana, elige una cosa sobre la que hablarás—aunque esté fuera de tu zona de confort.",
      careerAdvice:
        '<p class="text-gray-700 mb-4">Prosperas en roles que permiten reflexión, investigación e impacto. Ambientes estratégicos que valoran la visión sobre el volumen son ideales para ti.</p><p class="text-gray-700 mb-4">Busca:</p><ul><li>● Think tanks u organizaciones de defensa </li><li>● Roles de política e investigación </li><li>● Puestos de planificación estratégica </li><li>● Desarrollo de liderazgo y cambio organizacional</li></ul><p class="text-gray-700 mb-4 mt-4"><b>Evita:</b> ambientes que valoren la prisa sobre la reflexión, o donde la presión opaque el propósito.</p><p class="text-gray-700 mb-4"><i><b>Microconsejo de Coaching:</b> Pregunta en entrevistas: “¿Cómo equilibra su organización la acción con el pensamiento a largo plazo?”</i></p>',
      personalizeRoadMap: {
        initial: [
          "Identifica un sistema o patrón en el trabajo que quieras comprender más a fondo",
          "Programa bloques de trabajo tranquilos para pensar o escribir en profundidad ",
          "Comparte una reflexión o sugerencia en un entorno de equipo",
        ],
        midterm: [
          "Lidera una sesión de retroalimentación post-proyecto o informe de lecciones aprendidas",
          "Guía a alguien nuevo o más reactivo—modelo de tu estabilidad ",
          "Propón una estrategia de mejora o aprendizaje a largo plazo",
        ],
        longterm: [
          "Publica o presenta tus ideas en un foro interno de la empresa ",
          "Aboga por un cambio o innovación estratégica ",
          "Crea un marco que otros puedan usar para resolver problemas de manera más efectiva",
        ],
        tips: "Crea legado, no solo resultados. ¿Qué estructuras o ideas puedes dejar para que otros construyan sobre ellas?",
      },
      careerRoles: [
        "Planificador Estratégico ",
        "Analista de Investigación ",
        "Asesor de Políticas ",
        "Especialista en Desarrollo Organizacional ",
        "Administrador Universitario ",
        "Educador o Académico ",
        "Coach o Consultor de Liderazgo",
        "Estratega de Sostenibilidad",
      ],
      rolesAvoidIntro:
        "Estos roles pueden agotar tus fortalezas o ignorar tu visión a largo plazo:",
      rolesAvoid: [
        "Ventas de alto volumen ",
        "Atención al cliente bajo constante presión",
        "Planificación de eventos o logística en entornos caóticos",
        "Culturas de startups ultra-rápidas con visión poco clara",
      ],
      prefferedWork: {
        intro:
          "Trabajas mejor con tiempo, espacio y propósito. Tu estilo es medido, consciente y motivado internamente. No te gusta la urgencia forzada y prefieres la sustancia sobre lo superficial. Das lo mejor cuando se confía en ti con autonomía e impacto.",
        need: [
          "Tiempo de reflexión",
          "Alineación con propósito",
          "Liderazgo centrado en valores",
          "Una cultura que escucha",
        ],
        tip: "Reserva 90 minutos cada semana para una “ventana de visión”, un momento para pensar sin reaccionar. Tu genialidad florece en la quietud.",
      },
      idealEnvironment: {
        need: [
          "Instituciones con propósito",
          "ONGs visionarias o entornos académicos",
          "Divisiones estratégicas dentro de grandes organizaciones ",
          "Ambientes que valoren retroalimentación, ética y crecimiento",
        ],
        story:
          "Elena, una Cóndor, lideró la estrategia de retención universitaria a largo plazo. Era callada en las reuniones—pero sus ideas cambiaron políticas y aumentaron la retención estudiantil en un 20%.",
      },
      aiPrompts: {
        title: "Prompts de IA para el crecimiento del Cóndor",
        intro: "Usa estos prompts para guiar tu crecimiento y contribución:",
        need: [
          "“Ayúdame a traducir una idea estratégica en una presentación.” ",
          "“¿Cómo puedo cuestionar suavemente una idea miope sin generar conflicto?” ",
          "“¿Cuáles son 5 fortalezas de liderazgo silencioso y cómo puedo hacerlas mías?” ",
          "“¿Cuál es una forma calmada y segura de contribuir en una reunión ruidosa?”",
        ],
        tip: "Agrega “como un Cóndor” para obtener respuestas matizadas alineadas con tus fortalezas.",
      },
      affirmation:
        "“Veo lo que otros no ven. Guío con sabiduría, lidero con claridad y sirvo con visión.”",
      latinovalues: {
        intro:
          "Honras la tradición mientras creas una nueva visión. Lideras de maneras que a menudo no se ven—pero sí se sienten. Eres la fuerza silenciosa que trae transformación.",
        values: [
          "Sabiduría y Humildad",
          "Sacrificio",
          "Crecimiento",
          "Legado Cultural",
        ],
      },
      powerQuote:
        "No persigues los reflectores—elevas la altitud. Confía en tu perspectiva. Habla tu verdad. Y eleva a otros con tu claridad.<br/><br/><b>Haz tuya tu altitud. Expande tu legado. Sé el Cóndor.</b>",
    },
    quetzal: {
      fullTitle: "Quetzal",
      intro:
        "El Quetzal es el profesional visionario, expresivo y guiado por la creatividad. Prosperas con ideas, belleza, originalidad y la oportunidad de traer algo nuevo al mundo. Como el quetzal resplandeciente—reverenciado en la cultura mesoamericana por su belleza y libertad—eres vibrante, imaginativo e inspirador.<br/><br/>Tu don está en tu capacidad de dar significado al caos. Ves posibilidades donde otros ven problemas. Aportas color a los espacios grises, chispa a los sistemas estancados y corazón a las estrategias empresariales. <br/><br/><i><b>Perspectiva del Coach José Piñero:</b> Eres el alma de la innovación. Pero recuerda: la creatividad se convierte en poder cuando se combina con acción constante. No solo sueñes—diseña.</i>",
      description:
        "Creativo. Con propósito. Libre. Como Quetzal, te impulsa el significado, la expresión y el profundo deseo de vivir la vida a tu manera. No estás aquí para seguir modas, sino para seguir la verdad. Tu creatividad, tus valores y tu individualidad te distinguen en cada espacio.",
      shortintro:
        "El Quetzal es un visionario creativo que transforma ideas en belleza, significado e innovación que inspiran a otros.",
      archnarrative:
        "En muchas culturas mesoamericanas, el quetzal simbolizaba libertad, creatividad y poder sagrado. Como Quetzal moderno, eres la fuerza imaginativa que eleva a los equipos más allá de lo ordinario. Puedes ser el diseñador, el narrador, el generador de ideas o quien se atreve a desafiar el statu quo con elegancia y profundidad.<br/><br/>Expresas tus valores a través del color, el lenguaje y la inteligencia emocional. Pero, debido a que tus dones son menos “lineales”, a veces puedes sentirte invisible o poco valorado en entornos corporativos tradicionales. No apagues tu brillo. En cambio, aprende a estructurarlo.<br/><br/><b>Si te sientes estancado:</b> Puede que estés lleno de ideas pero sin saber por dónde empezar. Elige una. Comienza con algo pequeño. La creatividad se aclara creando.",
      strengths: [
        "Pensamiento creativo y visual sólido",
        "Inteligencia emocional y empatía",
        "Visión y alineación con valores",
        "Habilidad para contar historias y comunicar",
        "Originalidad e innovación",
        "Capacidad para conectar arte, estrategia y corazón",
      ],
      quicktips:
        "Mantén una lista de “incubación de ideas”—captura tus chispas sin presión por actuar de inmediato.",
      growthAreasIntro:
        "Incluso los arquetipos más expresivos necesitan estructura. Como Quetzal, tu crecimiento puede venir de:",
      growthAreas: [
        "<strong>Dar seguimiento:</strong> Las ideas son semillas—los resultados llegan al cultivarlas.",
        "<strong>Construir disciplina creativa:</strong> La creatividad necesita constancia para florecer.",
        "<strong>Aceptar retroalimentación:</strong> Protege tu visión, pero invita aportes para que evolucione.",
        "<strong>Comunicar con claridad:</strong> Aprende a presentar ideas en términos accionables para otros.",
      ],
      microCoachingTips:
        "Antes de presentar una idea, define audiencia, resultado y cronograma. Visión + estructura = impacto.",
      careerAdvice:
        '<p class="text-gray-700 mb-4">Prosperas en entornos que valoran la originalidad, el diseño y el pensamiento expresivo. Busca roles donde la creatividad no sea un “extra”, sino una función central. Brillas cuando puedes explorar, crear e influir con propósito.</p><p class="text-gray-700 mb-4">Busca:</p><ul><li>● Estrategia de marca y contenido</li><li>● Agencias creativas, medios o estudios de diseño</li><li>● Equipos de innovación en empresas</li><li>● Organizaciones sin fines de lucro y plataformas de narración</li></ul><p class="text-gray-700 mb-4 mt-4"><b>Evita:</b> Entornos rígidos, burocráticos o que desestimen la inteligencia visual y emocional.</p><p class="text-gray-700 mb-4"><i><b>Microconsejo:</b> Pregunta en entrevistas: “¿Cómo se desarrollan e implementan las ideas creativas aquí?”</i></p>',
      personalizeRoadMap: {
        initial: [
          "Identifica 1–2 proyectos creativos en los que quieras participar o iniciar",
          "Empieza a crear un portafolio o “brag book” de tu trabajo creativo",
          "Registra diariamente chispas creativas o emociones que impulsen tus ideas",
        ],
        midterm: [
          "Propón una iniciativa creativa que resuelva una necesidad real en el trabajo",
          "Colabora con alguien detallista para afinar la ejecución",
          "Practica presentar tus ideas en 3 formatos: visual, narrativo y estratégico",
        ],
        longterm: [
          "Postúlate para una oportunidad de liderazgo o vocería",
          "Comienza a asesorar o mentorizar a otros creativos",
          "Desarrolla tu marca o marco creativo personal",
        ],
        tips: "No necesitas esperar permiso para crear. Innova dentro de tu trabajo, no solo fuera de él.",
      },
      careerRoles: [
        "Estratega de Marca",
        "Diseñador UX/UI",
        "Creador de Contenido o Copywriter",
        "Director Creativo o Líder de Marketing",
        "Narrador Cultural o Curador de Programas",
        "Gerente de Redes Sociales",
        "Diseñador de Campañas",
        "Consultor de Innovación",
        "Conferencista o Facilitador de Talleres",
      ],
      rolesAvoidIntro:
        "Estos roles pueden limitar tus fortalezas o tu potencial creativo:",
      rolesAvoid: [
        "Roles centrados en datos sin espacio creativo",
        "Trabajos con procesos rígidos sin margen para la expresión",
        "Entornos que prioricen la uniformidad sobre la originalidad",
        "Puestos sin diseño, narrativa ni interacción humana",
      ],
      prefferedWork: {
        intro:
          "Trabajas mejor en entornos expresivos y flexibles donde puedas combinar tiempo creativo en solitario con exploración colaborativa. Prosperas con inspiración visual, emocional y conceptual.",
        need: [
          "Autonomía creativa",
          "Espacio para experimentar y jugar",
          "Conexión emocional con tu trabajo",
          "Una misión o mensaje que importe",
        ],
        tip: 'Comienza cada semana con una intención creativa: “Esta semana quiero inspirar…” Eso centra tu visión.',
      },
      idealEnvironment: {
        need: [
          "Estudios creativos y laboratorios de innovación",
          "ONG o campañas con valores fuertes",
          "Espacios de marketing, medios o educación",
          "Equipos diversos que celebren la expresión y la cultura",
        ],
        story:
          "Diego, un Quetzal, comenzó como pasante de redes sociales y propuso una campaña de marca con raíces culturales. Se volvió viral—y lo ascendieron a Líder Creativo en un año.",
      },
      aiPrompts: {
        title: "Prompts de IA para el Crecimiento del Quetzal",
        intro: "Úsalos con herramientas como ChatGPT para potenciar tu creatividad:",
        need: [
          "“Ayúdame a proponer una idea de marca que conecte cultura e innovación.”",
          "“¿Cuáles son 3 formas de desarrollar disciplina creativa como pensador visionario?”",
          "“Diseña un planificador semanal para creación de contenido con corazón y estructura.”",
          "“¿Cómo cuento una historia impactante usando imágenes y narrativa?”",
        ],
        tip: "Añade “como Quetzal” al final de tus prompts para reflejar tu estilo creativo y guiado por valores.",
      },
      affirmation:
        "“Creo belleza, significado y cambio. Mi voz importa. Mi visión inspira. Mi creatividad transforma.”",
      latinovalues: {
        intro:
          "Eres el puente entre la tradición y la imaginación. Das vida a nuestras historias y recuerdas a otros que la emoción, el arte y la identidad son herramientas poderosas para generar impacto.",
        values: [
          "Orgullo Cultural",
          "Comunicación",
          "Crecimiento",
          "Autoexpresión",
        ],
      },
      powerQuote:
        "YNaciste para inspirar, imaginar y expresar lo que otros aún no ven. Mantente audaz. Mantente vibrante. Mantente fiel.<br/><br/><b>Haz tuya tu voz. Moldea tu visión. Sé el Quetzal.</b>",
    },
    colibri: {
      fullTitle: "Colibrí",
      intro:
        "El Colibrí es un profesional alegre, enérgico y altamente adaptable. Como el colibrí, te mueves con rapidez, prosperas en la interacción y aportas ligereza, creatividad y dinamismo a cualquier espacio que ocupes. Sueles ser la chispa del equipo: una fuente de energía, rapidez y encanto.<br/><br/>Eres especialmente efectivo en entornos dinámicos donde el cambio es constante y la adaptabilidad es clave. Tu capacidad para pivotar, realizar múltiples tareas y elevar el ánimo de quienes te rodean te convierte en un colaborador valioso en roles colaborativos y dinámicos. <br/><br/><i><b>Perspectiva del Coach José Piñero:</b> Como coach de miles de profesionales latinos, he visto a los Colibrís volar alto cuando dejan de ocultar su energía y comienzan a reconocer su influencia. Usa tu alegría como tu superpoder.</i>",
      description:
        "Ligero. Rápido. Alegre. Adaptable. Eres una explosión de energía en cada espacio que entras. Como Colibrí, te mueves con agilidad, inspiras optimismo a quienes te rodean y te desenvuelves en entornos llenos de movimiento, gente y propósito.",
      shortintro:
        "El Colibrí es un profesional enérgico y adaptable que aporta alegría, eficiencia y movimiento a su trabajo.",
      archnarrative:
        "El Colibrí refleja el pulso de la resiliencia latina moderna. Rápido para actuar y aún más rápido para inspirar, encarnas un espíritu vivo que imita el vuelo del colibrí: ligero, intencional e inspirador. Eres el compañero que todos recuerdan, el que trae risa en medio del estrés y el talento que prospera con el impulso.<br/><br/>Tu arquetipo simboliza con frecuencia la agilidad emocional y la positividad. En las tradiciones latinas, el colibrí también es un mensajero y un puente entre mundos. Tú, de igual manera, eres el puente: entre departamentos, entre compañeros, entre el caos y la calma.<br/><br/><b>Si te sientes estancado:</b> Enfoca tu energía en un área donde puedas aportar más movimiento o creatividad. Incluso un pequeño logro puede devolverte el control.",
      strengths: [
        "Aprendizaje rápido y ejecución ágil",
        "Alta adaptabilidad en entornos cambiantes",
        "Energía positiva e inyecta humor",
        "Naturalmente colaborativo y orientado a las personas",
        "Gran habilidad para gestionar múltiples tareas",
        "Tomador de decisiones rápido",
        "Excelente para resolver problemas a corto plazo",
      ],
      quicktips:
        "Haz una lista diaria de 3 logros rápidos antes del mediodía. El impulso construye confianza.",
      growthAreasIntro:
        "Incluso los arquetipos más radiantes tienen áreas por pulir. Como Colibrí, podrías enfrentar retos con:",
      growthAreas: [
        "<strong>Mantener enfoque en objetivos a largo plazo:</strong> Crea estructura con revisiones y hitos. Colabora con compañeros orientados al largo plazo.",
        "<strong>Profundidad sobre velocidad:</strong> Tu superpoder es la rapidez, pero tómate tiempo para analizar.",
        "<strong>Gestión de energía:</strong> Tu vitalidad natural puede llevarte al agotamiento. Prioriza descanso y planeación realista.",
        "<strong>Evitar sobrecompromisos:</strong> Aprende a decir no. Elige acciones de alto impacto.",
      ],
      microCoachingTips:
        "Cada viernes, revisa tus tres prioridades principales. ¿Son estratégicas o solo urgentes?",
      careerAdvice:
        '<p class="text-gray-700 mb-4">Busca roles que recompensen la agilidad, la rapidez y la creatividad. Tu punto fuerte son los entornos cambiantes donde se valore la inteligencia emocional. Trabaja con líderes que aprecien la experimentación y permitan innovar.</p><p class="text-gray-700 mb-4">Busca:</p><ul><li>● Startups</li><li>● Roles de contacto con clientes</li><li>● Equipos dinámicos y de ritmo rápido</li><li>● Posiciones multifuncionales</li></ul><p class="text-gray-700 mb-4 mt-4"><b>Evita:</b> Cadenas burocráticas extensas, puestos que requieran análisis profundo en aislamiento o empresas que se muevan lentamente.</p><p class="text-gray-700 mb-4"><i><b>Microconsejo:</b> Pregunta en entrevistas: “¿Qué tan rápido avanzan las ideas nuevas en la empresa?”</i></p>',
      personalizeRoadMap: {
        initial: [
          "Evalúa tus hábitos de tiempo. Usa bloques de tiempo.",
          "Pide retroalimentación a 2 colegas o mentores de confianza.",
          "Alinea tu trabajo con proyectos que requieran energía y urgencia.",
        ],
        midterm: [
          "Únete a un equipo multifuncional.",
          "Comienza a mentorizar o apoyar a otros informalmente.",
          "Explora pequeñas oportunidades de liderazgo.",
        ],
        longterm: [
          "Lidera un reto de innovación o sprint.",
          "Profundiza en una habilidad clave (ej. datos, estrategia, oratoria).",
          "Define un objetivo a largo plazo y crea el plan inverso.",
        ],
        tips: "Usa temas mensuales. “Mayo: mes de oratoria.” El enfoque profundo impulsa el crecimiento.",
      },
      careerRoles: [
        "Coordinador de Marketing",
        "Gerente de Campañas",
        "Embajador de Marca",
        "Gerente de Experiencia del Cliente",
        "Organizador de Eventos",
        "Estratega Creativo",
        "Gerente de Proyectos",
        "Reclutador / Scout de Talento",
        "Asociado de Operaciones",
        "Especialista en Innovación",
      ],
      rolesAvoidIntro:
        "Estos pueden limitar tu potencial o drenar tu energía natural:",
      rolesAvoid: [
        "Auditor / Controlador Financiero",
        "Científico de Datos (roles aislados y analíticos)",
        "Investigador de Políticas",
        "Redactor Técnico",
        "Analista de Cumplimiento",
        "Investigación académica extensa",
        "Puestos con burocracia excesiva y poco movimiento",
      ],
      prefferedWork: {
        intro:
          "Trabajas mejor en ráfagas creativas. Tu ritmo ideal es rápido, interactivo y centrado en personas. Disfrutas manejar múltiples tareas y prosperas cuando otros se contagian de tu energía. La rutina ayuda, pero demasiada previsibilidad puede sofocarte.",
        need: [
          "Flexibilidad",
          "Conexión social",
          "Sprints cortos",
          "Logros rápidos",
        ],
        tip: 'Reserva una hora diaria para “jam session” de trabajo enfocado y veloz.',
      },
      idealEnvironment: {
        need: [
          "Organizaciones con energía joven y propósito claro",
          "Equipos que recompensen la iniciativa y no micromanejen",
          "Culturas con retroalimentación, flexibilidad y celebración",
          "Canales de comunicación rápidos y claros",
        ],
        story:
          "María, una Colibrí, brilló en una startup en crecimiento. Creó un sistema de reconocimiento entre pares que elevó la moral del equipo y le consiguió un rol de liderazgo en 8 meses.",
      },
      aiPrompts: {
        title: "Prompts de IA para el Crecimiento del Colibrí",
        intro: "Prueba estos prompts con herramientas como ChatGPT:",
        need: [
          '“Dame 5 trucos de productividad para alguien que se mueve rápido y maneja muchas cosas.”',
          '“¿Cuáles son 3 formas nuevas de aportar alegría a mi equipo esta semana?”',
          '“¿Cómo puedo gestionar mejor mi energía durante el día?”',
          '“¿Qué trabajos son ideales para alguien creativo, rápido y sociable?”',
          '“Ayúdame a idear proyectos divertidos e impactantes para mi equipo.”',
        ],
        tip: "Añade “como Colibrí” al final de tus prompts para recibir consejos más personalizados.",
      },
      affirmation:
        "Soy ligereza, soy movimiento, soy alegría en acción. Aporto claridad, energía y presencia dondequiera que voy.",
      latinovalues: {
        intro:
          "Esto significa que te impulsan las relaciones, la autoexpresión y el orgullo por tu identidad. Sueles ser el traductor—entre culturas, ideas o equipos.",
        values: [
          "Comunicación",
          "Crecimiento",
          "Orgullo Cultural",
          "Tenacidad y Empuje",
          "Lealtad al Grupo",
        ],
      },
      powerQuote:
        "Este es tu momento para canalizar tu energía, estructurar tu crecimiento y liderar con la ligereza y la alegría que solo un Colibrí puede aportar.<br/><br/><b>Extiende tus alas. Déjalas llevarte más lejos de lo que imaginaste.</b>",
    },
    coqui: {
      fullTitle: "Coquí",
      intro:
        "El Coquí es el profesional centrado en las personas, con inteligencia emocional y un fuerte compromiso con la comunidad. Como la pequeña rana cuyo canto resuena en las noches de Puerto Rico, puede que no seas la voz más fuerte, pero tu presencia es poderosa. Aportas conexión, compasión y calidez a cada espacio que ocupas.<br/><br/>Lideras escuchando, apoyas empatizando y brillas creando espacios seguros e inclusivos. Ya sea al frente o tras bastidores, tu radar emocional ayuda a los equipos a sentirse equilibrados, escuchados y humanos.<br/><br/><i><b>Perspectiva del Coach José Piñero:</b> Tú recuerdas a las personas lo que realmente importa. Pero no olvides que tú también mereces apoyo. Protege tu paz con la misma fuerza con la que proteges a los demás.</i>",
      description:
        "Solidario. Con los pies en la tierra. Leal. Como <b>Coquí</b>, no solo lideras con el corazón, sino que también eres el alma del equipo. Te muestras para los demás, proteges lo que importa y brindas seguridad emocional a quienes te rodean. Puede que no siempre hables primero, pero tu presencia es poderosa e inolvidable.",
      shortintro:
        "El Coquí es un profesional empático e inteligente emocionalmente, que fomenta conexión, confianza y sentido de pertenencia dondequiera que va.",
      archnarrative:
        "El Coquí es un símbolo cultural muy querido en Puerto Rico—pequeño pero poderoso, siempre presente y profundamente conectado con el alma de la isla. De forma similar, tú sueles ser el centro emocional de tus equipos. No solo haces el trabajo, también cuidas de las personas que lo hacen.<br/><br/>Ya sea organizando una tarjeta de cumpleaños, mediando tensiones en el equipo o ayudando a un colega a sentirse seguro para expresarse, lideras desde el corazón. Tu intuición es aguda. Tu empatía es poderosa. Y tu cuidado es tu superpoder.<br/><br/><b>Si te sientes estancado:</b> Puede que estés dando demasiado. Haz una pausa y pregúntate: “¿Qué necesito hoy?” Tu bienestar es esencial para tu impacto.",
      strengths: [
        "Alta inteligencia emocional y empatía",
        "Capacidad para crear entornos seguros y de confianza",
        "Desescalada de conflictos y apoyo emocional",
        "Lealtad profunda y compromiso con las relaciones",
        "Comprensión intuitiva de la dinámica grupal",
        "Defensa constante de la inclusión y la equidad",
      ],
      quicktips:
        "Eres un cuidador—pero no olvides que los cuidadores también necesitan cuidado. Reserva una hora a la semana solo para ti.",
      growthAreasIntro:
        "Incluso los arquetipos más protectores necesitan límites. Como Coquí, ten presente:",
      growthAreas: [
        "<strong>Sobrecarga emocional:</strong> No eres responsable de los sentimientos de todos. Permite que otros gestionen su propio crecimiento.",
        "<strong>Evitar conversaciones difíciles:</strong> La bondad incluye honestidad. Habla con compasión, pero con verdad.",
        "<strong>Ponerte en último lugar:</strong> Tus necesidades importan. Prioriza el descanso y la alegría.",
        "<strong>Buscar validación externa:</strong> Tu valor no depende del bienestar ajeno.",
      ],
      microCoachingTips:
        "Di “sí” solo cuando realmente quieras decirlo, no cuando esperas que cancelen. La alineación importa.",
      careerAdvice:
        '<p class="text-gray-700 mb-4">Prosperas en roles centrados en las personas y en organizaciones impulsadas por una misión. Brillas en espacios que valoran el trabajo emocional, el liderazgo relacional y la inclusión. Tu estilo de liderazgo es silencioso, constante y profundamente transformador.</p><p class="text-gray-700 mb-4">Busca:</p><ul><li>● Roles en recursos humanos, cultura, desarrollo profesional, adiestramiento, coaching o desarrollo de personas</li><li>● Campos de salud y bienestar</li><li>● Posiciones en diversidad, equidad e inclusión</li><li>● Organizaciones comunitarias y de educación</li></ul><p class="text-gray-700 mb-4 mt-4"><b>Evita:</b> Roles donde la empatía se vea como debilidad o donde los resultados importen más que las personas.</p><p class="text-gray-700 mb-4"><i><b>Microconsejo:</b> Pregunta en entrevistas: “¿Cómo se cuidan los miembros del equipo entre sí?” La cultura importa más que los beneficios.</i></p>',
      personalizeRoadMap: {
        initial: [
          "Define límites personales sobre energía y disponibilidad",
          "Identifica 2 personas que te recarguen y agenda tiempo con ellas",
          "Organiza un check-in o momento de bienestar en el equipo—tu presencia es tu don",
        ],
        midterm: [
          "Ofrécete para liderar o co-liderar una iniciativa de DEI o bienestar",
          "Practica decir no con claridad y amabilidad",
          "Explora desarrollo profesional en consejería, coaching o facilitación",
        ],
        longterm: [
          "Aboga por entrenamientos en inteligencia emocional en tu trabajo",
          "Solicita un título o rol que refleje tu impacto en las personas",
          "Diseña un proceso o ritual que fomente la conexión del equipo",
        ],
        tips: "Haz seguimiento de tu trabajo emocional. Nómbralo. Documenta. Úsalo como palanca—es valioso, incluso cuando es invisible.",
      },
      careerRoles: [
        "Socio de recursos humanos, cultura, desarrollo profesional, adiestramiento, o Líder de Operaciones de Personas",
        "Gerente de Programas de Bienestar, cultura o DEI",
        "Consejero escolar o asesor universitario",
        "Mediador de conflictos o facilitador organizacional",
        "Líder de Experiencia del Cliente",
        "Trabajador social o defensor comunitario",
        "Gerente de Cultura Organizacional",
        "Estratega de Experiencia del Empleado",
      ],
      rolesAvoidIntro:
        "Estos roles pueden ignorar tu profundidad emocional o explotar tu empatía:",
      rolesAvoid: [
        "Ventas de alta presión con rechazo constante",
        "Entornos rígidos y jerárquicos sin espacio emocional",
        "Empresas que minimizan la salud mental y la inclusión",
        "Roles aislados sin interacción humana",
      ],
      prefferedWork: {
        intro:
          "Trabajas mejor en entornos que valoran los sentimientos, la conexión y la misión. A menudo asumes el papel de “líder emocional” del equipo, reconocido o no. Prefieres la colaboración en grupos pequeños y los espacios donde puedas expresarte auténticamente.",
        need: [
          "Seguridad emocional",
          "Tiempo para reflexionar y procesar",
          "Relaciones de apoyo",
          "Claridad en límites y expectativas",
        ],
        tip: "Añade un “minuto de salud mental” a tu rutina diaria. Respira, estira, hidrátate, reinicia.",
      },
      idealEnvironment: {
        need: [
          "Organizaciones con misión social o sin fines de lucro",
          "Escuelas o departamentos universitarios",
          "Organizaciones centradas en recursos humanos, cultura, desarrollo profesional, adiestramiento, DEI o bienestar",
          "Startups y empresas que prioricen el sentido de pertenencia",
        ],
        story:
          "Julissa, una Coquí, era conocida por su apoyo a compañeros y rituales de equipo. Tras crear una herramienta de bienestar mental, fue ascendida a Directora de Recursos Humanos y Cultura.",
      },
      aiPrompts: {
        title: "Prompts de IA para el Crecimiento del Coquí",
        intro: "Úsalos con herramientas como ChatGPT para impulsar tu desarrollo:",
        need: [
          "“Ayúdame a decir no sin sentir culpa como miembro de equipo solidario.”",
          "“¿Cómo puedo crear espacio para mis necesidades mientras cuido a otros?”",
          "“Diseña un ritual diario de reflexión para proteger mi energía emocional.”",
          "“Dame estrategias para dar retroalimentación honesta y amable.”",
        ],
        tip: "Añade “como Coquí” al final de tus prompts para obtener recomendaciones alineadas con tu profundidad emocional.",
      },
      affirmation:
        "Cuido con propósito. Escucho con amor. Lidero a través del cuidado—y mis límites protegen mi brillo.",
      latinovalues: {
        intro:
          "Eres el latido emocional de nuestra comunidad. Cuidas de otros no por obligación, sino como una ofrenda sagrada. Solo recuerda: tu alegría y bienestar también importan.",
        values: ["Familia", "Respeto", "Lealtad al Grupo", "Comunicación"],
      },
      powerQuote:
        "Aportas calidez a los espacios fríos, voz a los que no son escuchados y sanación a los lugares que más lo necesitan. Lidera con el corazón. Enraíza tu cuidado. Sé el Coquí.",
    },
    buho: {
      fullTitle: "Búho",
      intro:
        "El Búho es el profesional sabio, analítico y silenciosamente poderoso. Como el búho que ve en la noche, observas en profundidad, piensas de manera crítica y aportas claridad en medio de la confusión. Detectas patrones que otros no ven y resuelves problemas desde la calma, la inteligencia y la precisión.<br/><br/>No siempre necesitas los reflectores, pero cuando hablas, importa. Tu mente es tu regalo, y tu capacidad de mantener la reflexión en el caos es poco común. Otros confían en tu criterio, tu lógica serena y tu atención al detalle.<br/><br/><i><b>Perspectiva del Coach José Piñero:</b> No solo piensas, <b>ves</b>. Tu habilidad para pausar, reflexionar y elegir sabiamente te convierte en una voz confiable. Solo recuerda: incluso la sabiduría silenciosa merece ser escuchada.</i>",
      description:
        "Sabio. Clarivo. Reflexivo. Como Búho, ves lo que otros no ven. Eres tranquilo bajo presión, preciso en tus pensamientos y arraigado en tus valores. No necesitas ser ruidoso para ser poderoso; tu discreta perspicacia suele ser la que más habla.",
      shortintro:
        "El Búho es un profesional calmado y reflexivo que aporta claridad, lógica y perspectiva incluso en los problemas más complejos.",
      archnarrative:
        "El búho es un símbolo sagrado en toda América Latina, asociado con la sabiduría, la percepción y el misterio. Como Búho, llevas esos mismos dones: visión, profundidad y discernimiento.<br/><br/>Probablemente eres quien lee entre líneas, quien detecta errores pequeños antes de que se agranden y quien ofrece retroalimentación precisa y oportuna. Mientras otros reaccionan, tú reflexionas. Mientras otros se apresuran, tú perfeccionas.<br/><br/>Puede que al principio te subestimen, pero tu impacto crece con el tiempo. No siempre eres el primero en hablar, pero tu presencia eleva el nivel de pensamiento en cada espacio al que entras.<br/><br/><b>Si te sientes estancado:</b> Puede que esperes la respuesta perfecta. Da el siguiente mejor paso. La acción revela la claridad, no solo al revés.",
      strengths: [
        "Pensamiento analítico y crítico profundo",
        "Orientación al detalle y precisión",
        "Fuerte capacidad para reconocer patrones",
        "Resolución estratégica de problemas",
        "Serenidad bajo presión",
        "Altos estándares de lógica y claridad",
      ],
      quicktips:
        "Cuando te sientas abrumado, simplifica el sistema. Tú ves cómo se conectan las partes; usa ese don para restaurar la claridad.",
      growthAreasIntro:
        "Incluso los arquetipos más reflexivos necesitan impulso. Como Búho, enfócate en:",
      growthAreas: [
        "<strong>Hablar antes:</strong> Tus ideas importan, no esperes la perfección.",
        "<strong>Equilibrar lógica con emoción:</strong> Las personas recuerdan cómo las hiciste sentir.",
        "<strong>Soltar el control:</strong> A veces, hecho es mejor que perfecto.",
        "<strong>Colaborar en medio del caos:</strong> El progreso suele parecer desordenado al inicio—acostúmbrate.",
      ],
      microCoachingTips:
        "Antes de cada reunión, escribe una idea que quieras aportar. Dila temprano. Tu presencia serena tranquilizará a otros.",
      careerAdvice:
        '<p class="text-gray-700 mb-4">Prosperas en roles que valoran el análisis, la estructura y la excelencia. Brillas cuando confían en ti para trabajar de forma independiente, resolver problemas complejos y priorizar calidad sobre cantidad. Prefieres la lógica sobre las suposiciones y el valor sobre la apariencia.</p><p class="text-gray-700 mb-4">Busca:</p><ul><li>● Roles centrados en datos, investigación y estrategia</li><li>● Finanzas, políticas o diseño de productos</li><li>● Trabajo de consultoría o asesoría</li><li>● Equipos técnicos con ética y estructura sólida</li></ul><p class="text-gray-700 mb-4 mt-4"><b>Evita:</b> Ventas de alta presión, campañas creativas aceleradas o entornos donde las decisiones se toman sin datos ni reflexión.</p><p class="text-gray-700 mb-4"><i><b>Microconsejo:</b> Pregunta en entrevistas: “¿Cómo se mide el éxito aquí y cómo se define la calidad?”</i></p>',
      personalizeRoadMap: {
        initial: [
          "Identifica patrones en tu trabajo y detecta ineficiencias para mejorar",
          "Propón una mejora estratégica en el trabajo",
          "Encuentra un mentor que valore la precisión y el crecimiento",
        ],
        midterm: [
          "Lidera un informe, auditoría o proyecto que requiera análisis agudo",
          "Diseña un flujo de trabajo o dashboard que aporte claridad",
          "Presenta tus ideas en una reunión combinando historia + datos",
        ],
        longterm: [
          "Mentorea a un colega o interno detallista",
          "Comparte tu visión en un blog, serie de emails o taller",
          "Evalúa tu perfeccionismo y optimiza donde frene tu avance",
        ],
        tips: "Para ti, crecer no es solo pensar más profundo, sino expresarlo con mayor claridad. Tu mente es tu herramienta, pero tu voz es la clave.",
      },
      careerRoles: [
        "Analista de datos o investigador",
        "Planificador financiero o auditor",
        "Estratega de producto o investigador UX",
        "Asesor de políticas o gestor de riesgos",
        "Analista legal o líder de cumplimiento",
        "Gerente de operaciones",
        "Redactor técnico o líder de documentación",
        "Arquitecto de sistemas o TI",
      ],
      rolesAvoidIntro:
        "Estos pueden desgastarte o desaprovechar tus fortalezas:",
      rolesAvoid: [
        "Puestos altamente emocionales frente al cliente",
        "Campañas creativas aceleradas y caóticas",
        "Trabajos sin sistemas claros, lógica o propósito",
        "Entornos donde tu minuciosidad se perciba como “demasiada”",
      ],
      prefferedWork: {
        intro:
          "Trabajas mejor con autonomía, estructura y objetivos claros. Te motivas solo y disfrutas tener tiempo para refinar antes de entregar. Valoras más la reflexión que la prisa. Construyes confianza con consistencia y competencia.",
        need: [
          "Expectativas y plazos claros",
          "Tiempo para pensar antes de actuar",
          "Espacio para trabajar de manera independiente",
          "Una cultura que valore líderes inteligentes y discretos",
        ],
        tip: "Reserva tiempo para “decidir” cada día. Date espacio para pensar, no solo reaccionar.",
      },
      idealEnvironment: {
        need: [
          "Organizaciones estructuradas con liderazgo reflexivo",
          "Equipos que valoren lógica, claridad y precisión",
          "Lugares donde se empodere a los introvertidos y pensadores",
          "Entornos con roles definidos, reglas claras y respeto",
        ],
        story:
          "Luis, un Búho, lideró la reorganización de la base de conocimiento de su empresa. Su atención a la estructura ahorró cientos de horas, le valió un reconocimiento y duplicó la eficiencia en la capacitación de personal nuevo.",
      },
      aiPrompts: {
        title: "Prompts de IA para el Crecimiento del Búho",
        intro:
          "Úsalos con herramientas como ChatGPT para potenciar tu claridad y liderazgo:",
        need: [
          "“¿Cuál es la estructura más lógica para este plan de proyecto?”",
          "“¿Cómo puedo expresar un análisis con más calidez emocional?”",
          "“Diseña una plantilla semanal para la toma estratégica de decisiones.”",
          "“Dame lenguaje de coaching que combine precisión y empatía.”",
        ],
        tip: "Añade “como Búho” para reflejar tu estilo lógico y reflexivo.",
      },
      affirmation:
        "Honras la tradición a través de la maestría. Lideras no por volumen, sino con el ejemplo. Demuestras que la excelencia habla por sí sola—aunque en silencio.",
      latinovalues: {
        intro:
          "You honor tradition through mastery. You lead not by volume, but by example. You prove that excellence speaks volumes—even in silence.",
        values: ["Crecimiento", "Sacrificio", "Respeto", "Sabiduría y Autoridad"],
      },
      powerQuote:
        "Eres la mente clara en el caos, la presencia serena con poder, el pensador que convierte la visión en acción. Lidera con claridad. Confía en tu percepción. <b>Sé el Búho.</b>",
    },
    // [Additional archetypes would be defined here with similar detailed structure]
  };

  return data[archetype.toLowerCase()] || {};
}
